import React, { useEffect, useRef } from "react";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import DatePicker from "../ui/DatePicker";

interface IntakeNoteState {
  intakeDate: string;
  setIntakeDate: (date: string) => void;
  intakeNote: string | undefined;
  setIntakeNote: (note: string) => void;
  focus?: boolean;
}

const IntakeNote = ({ intakeDate, setIntakeDate, intakeNote, setIntakeNote, focus = false }: IntakeNoteState) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (focus) {
      inputRef?.current?.focus();
    }
  }, []);

  return (
    <>
      <Row className="mb-3 mx-0 px-0">
        <Col xs={12}>
          <FloatingLabel controlId="floatingInput" label="Intake Note">
            <Form.Control
              as="textarea"
              type="textarea"
              ref={inputRef}
              placeholder="Intake Note"
              value={intakeNote}
              onChange={(e) => setIntakeNote(e.target.value)}
            />
          </FloatingLabel>
        </Col>
      </Row>
      <Row className="mx-0 px-0">
        <Col xs={6}>
          <DatePicker label="Intake Date" currentValue={intakeDate} setCurrentValue={setIntakeDate} hasMaxDate={true} />
        </Col>
      </Row>
    </>
  );
};

export default IntakeNote;
